/* eslint-disable react/no-array-index-key */
import { ChangeEvent, memo, useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Resources from "../../config/Resources";
import CustomErrorText from "../CustomErrorText";

interface Props {
  className?: string;
  label: string;
  optionsClassName?: string;
  options: string[];
  onChange: (e: ChangeEvent<any>) => void;
  value: string;
  name: string;
  touched?: boolean;
  error?: string;
  setFieldTouched: (field: string, touched: boolean) => void;
  requiredStar?: boolean;
  innerClassName?: string;
  disabledField?: boolean;
  buttonBgColor?: string; // tailwind utitlity class required
  defaultValue?: string;
}
function CustomSelect({
  className,
  label,
  options,
  onChange,
  value,
  name,
  touched,
  error,
  setFieldTouched,
  optionsClassName,
  requiredStar,
  buttonBgColor,
  innerClassName,
  disabledField,
  defaultValue
}: Props) {
  const [isDropdownClicked, setIsDropdownClicked] = useState(false);
  return (
    <div className={className}>
      <div
        className={`rounded-lg border border-solid border-discoBall focus-within:border-2 focus-within:border-hotShot ${
          isDropdownClicked && "border-2 border-hotShot"
        } ${innerClassName}`}
      >
        <TextField
          disabled={disabledField}
          fullWidth
          select
          required={requiredStar}
          variant="filled"
          label={label}
          onChange={onChange}
          onBlur={() => setFieldTouched(name, true)}
          value={value}
          name={name}
          defaultValue={defaultValue}
          SelectProps={{
            onOpen: () => setIsDropdownClicked(true),
            onClose: () => setIsDropdownClicked(false),
            // eslint-disable-next-line react/no-unstable-nested-components
            IconComponent: () => (
              <div
                className={`absolute right-0 pointer-events-none text-purpleComet z-10 py-3.5 pl-2 pr-6.25 flex justify-center items-center ${
                  disabledField && "!bg-gray-200"
                } ${buttonBgColor}`}
              >
                <img
                  src={
                    isDropdownClicked
                      ? Resources.images.Select.upIcon
                      : Resources.images.Select.downIcon
                  }
                  alt="down arrow"
                />
              </div>
            ),
            MenuProps: {
              MenuListProps: {
                classes: {
                  root: "!z-50"
                }
              }
            },
            classes: {
              root: "!bg-white !cursor-pointer"
            }
          }}
          InputProps={{
            classes: {
              input: `!text-sm !leading-5 !font-medium !text-black !bg-white !rounded-lg !font-montserrat ${buttonBgColor}`,
              root: "!rounded-lg w-60 !text-left",
              disabled: "!bg-gray-200"
            },
            disableUnderline: true
          }}
          InputLabelProps={{
            classes: {
              root: "!text-sm !leading-5 !font-medium !text-platinumGranite !pt-0.5 !pb-2 !font-montserrat",
              shrink: "!text-purpleComet !text-xs"
            }
          }}
        >
          {options?.map((option, index) => (
            <MenuItem
              key={index}
              value={option}
              classes={{ root: `!font-montserrat !font-medium !z-50 ${optionsClassName}` }}
            >
              {option}
            </MenuItem>
          ))}
        </TextField>
      </div>
      {touched && error && <CustomErrorText text={error} type="error" />}
    </div>
  );
}

CustomSelect.defaultProps = {
  className: "",
  optionsClassName: "",
  requiredStar: false,
  buttonBgColor: "!bg-white",
  innerClassName: "",
  touched: "",
  error: "",
  disabledField: false,
  defaultValue: ""
};

export default memo(CustomSelect);
